export default __webpack_public_path__ + "assets/img/1f8c7cM.png";